var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-relative t-0 w-100"},[_c('div',{staticClass:"d-flex ai-center bg-test flex-column"},[_c('div',{staticClass:"d-flex flex-column bg-white content-block p-absolute"},[_c('router-view')],1)]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }